import {
    requestGet as wsRequestGet,
    requestPost as wsRequestPost,
} from "./_wsApiFetchData";

export async function getProviderAdminDetailsById(providerAdminId, language, timeZone, cancelToken) {
    try {
        const data = await wsRequestGet(
            "/admin/providerAdmin/getProviderAdminDetailsById",
            language,
            timeZone,
            { providerAdminId },
            cancelToken
        );
        return {
            success: true,
            data
        };
    }
    catch (e) {
        console.error(`unable to get provider admin details: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function getProviderAdminIdByUser(userId, language, timeZone, cancelToken) {
    try {
        const data = await wsRequestGet(
            "/admin/providerAdmin/getProviderAdminIdByUser",
            language,
            timeZone,
            { userId },
            cancelToken
        );

        if (data != null && data != undefined && data != "")
        {
            return {
                success: true,
                data
            };
        }else{
            return {
                success: false
            };
        }
    } catch (e) {
        console.error(`unable to get provider admin by user: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function addProviders(providers, providerAdminId, language, timeZone, cancelToken) {
    const providerIds = providers.map(provider => provider.value);
    try {
        const data = await wsRequestPost(
            "/admin/providerAdmin/addProviders",
            language,
            timeZone,
            { providerIds, providerAdminId },
            cancelToken
        );
        return {
            success: true,
            data
        };
    } catch (e) {
        console.error(`unable to add providers: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function addFacilities(facilities, providerAdminId, language, timeZone, cancelToken) {
    const facilityIds = facilities.map(facility => facility.value);
    try {
        const data = await wsRequestPost(
            "/admin/providerAdmin/addFacilities",
            language,
            timeZone,
            { facilityIds, providerAdminId },
            cancelToken
        );
        return {
            success: true,
            data
        };
    }
    catch (e) {
        console.error(`unable to add facilities: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function addUserToProviderAdmin(userId, language, timeZone, cancelToken) {
    try {
        const data = await wsRequestPost(`/admin/providerAdmin/addUserToProviderAdmin/${userId}`, language, timeZone, {}, null, cancelToken);
        return {
            success: true,
            data
        };
    } catch (e) {
        console.error(`unable to add user to provider admin: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function removeUserFromProviderAdmin(id, language, timeZone, cancelToken) {
    try {
        const data = await wsRequestPost(`/admin/providerAdmin/removeUserFromProviderAdmin/${id}`, language, timeZone, {}, null, cancelToken);
        return {
            success: true,
            data
        };
    } catch (e) {
        console.error(`unable to remove user from provider admin: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function removeProvider(providerId, providerAdminId, language, timeZone, cancelToken) {
    try {
        const data = await wsRequestPost(
            "/admin/providerAdmin/removeProvider",
            language,
            timeZone,
            { providerId, providerAdminId },
            cancelToken
        );
        return {
            success: true,
            data
        };
    } catch (e) {
        console.error(`unable to remove provider: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function removeFacility(facilityId, providerAdminId, language, timeZone, cancelToken) {
    try {
        const data = await wsRequestPost(
            "/admin/providerAdmin/removeFacility",
            language,
            timeZone,
            { facilityId, providerAdminId },
            cancelToken
        );
        return {
            success: true,
            data
        };
    } catch (e) {
        console.error(`unable to remove facility: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}

export async function getProviderAdmins(options, language, timeZone, cancelToken) {
    const { filters } = options;
    const {
        orderBy,
        orderDirection,
        id,
        user,
        facilityId,
        providerId,
        page,
        resultsPerPage,
        providerOrFacility
    } = filters;

    const params = {
        OrderBy: orderBy || "createdDate",
        OrderDirection: orderDirection || "desc",
        Page: page || 1,
        ResultsPerPage: resultsPerPage || 15,
        Id: id || undefined,
        User: user || undefined,
        FacilityId: facilityId || undefined,
        ProviderId: providerId || undefined,
        providerOrFacility: providerOrFacility || undefined
    };

    try {
        const data = await wsRequestGet(
            "/admin/providerAdmin/search",
            language,
            timeZone,
            params,
            cancelToken
        );
        return {
            success: true,
            data
        };
    } catch (e) {
        console.error(`unable to get provider admins: ${e}`);
        return {
            success: false,
            error: e
        };
    }
}